import React, { memo } from 'react';
import { ReportTypeSetting } from '../../../models/reportTypeSetting';

interface ReportSettingInforAPProps {
  onChange: (updatedValue: ReportSettingInforAPState) => void;
  reportSettingState: ReportSettingInforAPState;
  reportTypeSetting: ReportTypeSetting;
}

export interface ReportSettingInforAPState {
  from: string;
  to: string;
  isValid: boolean;
}

function ReportSettingInforAP({
}: ReportSettingInforAPProps): JSX.Element {

  return (
    <>
      
    </>
  );
}

export default memo(ReportSettingInforAP);
